import { ReactComponent as Arrow } from '../../../assets/arrow-left.svg'
import './index.scss'
import Slider from 'react-slick'
import classNames from 'classnames'
import { useRef, useState } from 'react'
const CustomSlider = ({
  children,
  settings,
  count,
}: {
  count: number
  children: any
  settings: any
}) => {
  const [current, setCurrent] = useState(0)
  const slider = useRef<any>(null)

  return (
    <div className={classNames('slider', 'white')}>
      <Slider
        {...settings}
        ref={slider}
        afterChange={(index: number) => setCurrent(index)}
      >
        {children}
      </Slider>
      <div className="slider__bottom">
        <div
          className={classNames('slider__btn back',
            // !current && 'disable'
          )}
          onClick={() => slider.current?.slickPrev()}
        >
          <Arrow />
        </div>
        <div
          className={classNames(
            'slider__btn next',
            // current + settings.slidesToShow == count && 'disable',
          )}
          onClick={() => slider.current?.slickNext()}
        >
          <Arrow />
        </div>
      </div>
    </div>
  )
}

export default CustomSlider
